import { fetch } from '@/utils/fetch';

export function _queryTopicGoods(
  {
    page, size, direction, sort, topicId,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/topic-goods`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
      topicId,
    },
  });
}

export function _queryLookBookTopicGoods(topicGoodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/topic-goods/${topicGoodsId}`,
    method: 'get',
  });
}

/**
 * 新增
 */
export function _addLookBookTopicGoodsList(
  {
    topicId,
    goodsIds,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/topic-goods-list`,
    method: 'post',
    data: {
      topicId,
      goodsIds,
    },
  });
}

export function _updateLookBookTopicGoodsList(topicGoodsId, {
  topicId,
  goodsIds,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/topic-goods-list/${topicGoodsId}`,
    method: 'post',
    data: {
      topicId,
      goodsIds,
    },
  });
}

/**
 * 上移
 */
export function _upTopicGoods(topicId, goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/topic-goods/${topicId}/${goodsId}/up`,
    method: 'patch',
  });
}

/**
 * 下移
 */
export function _downTopicGoods(topicId, goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/topic-goods/${topicId}/${goodsId}/down`,
    method: 'patch',
  });
}

/**
 * 推荐商品
 */
export function _recommendTopicGoods(topicId, goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/topic-goods/${topicId}/${goodsId}/recommend`,
    method: 'patch',
  });
}

export function _deleteTopicGoods(topicGoodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/topic-goods/${topicGoodsId}`,
    method: 'delete',
  });
}
export default {};
